import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface NewProjectModalStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useNewProjectModalStore = create<NewProjectModalStore>()(
  devtools((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }, undefined, 'newProjectModal/open'),
    close: () => set({ isOpen: false }, undefined, 'newProjectModal/close'),
  })),
);
